<template>
  <section class="step">
    <div class="wrapper">
      <slot />
    </div>
  </section>
</template>

<script>
import './viewportHeight';
export default {};
</script>

<style scoped src="./baseSection.css"></style>
